import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
// TODO move to client lib
// because effect hooks cannot depend on window.location anyway, we just do it statically
// only do this clientside
let queryParams;
if (typeof window !== 'undefined') {
    queryParams = new URLSearchParams(window.location.search);
}
// we do not have Object.fromEntries() yet, so we need to iterate and build the object manually
const initialParams = {};
if (queryParams) {
    for (const [key, value] of queryParams) {
        initialParams[key] = value;
    }
}
const paramsAtom = atom({
    key: 'queryParams',
    default: initialParams,
});
// we provide hooks just so we can easily replace it with a more sophisticated solution later
export function useParams() {
    return useRecoilValue(paramsAtom);
}
export function useParam(key, defaultValue = 'undefined') {
    const params = useParams();
    return params[key] || defaultValue;
}
export function useSetParams() {
    const params = useParams();
    const setParamsState = useSetRecoilState(paramsAtom);
    return function setParams(newParams) {
        const updatedParams = { ...params, ...newParams };
        setParamsState(updatedParams);
        window.history.replaceState(null, '', `?${new URLSearchParams(updatedParams).toString()}`);
    };
}
export function useSetParam(key) {
    const setParams = useSetParams();
    return function setParam(value) {
        setParams({ [key]: value });
    };
}
